import React from 'react';

const Shimmer = () => (
        <>
        <div className='shimmer-wrapper'>
            <div className='shimmer'/>
        </div>
        </>
    );

    export default Shimmer;